export enum MolModalGuideLinkVideoEnum {
  INTRO = "INTRO",
  HOW_TO_MANAGE_DELIVERY_AREAS = "HOW_TO_MANAGE_DELIVERY_AREAS",
  HOW_TO_MANAGE_OUTLETS = "HOW_TO_MANAGE_OUTLETS",
}
